<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Accusé De Reception Du Devis</h1>
    <div class="mb-6 flex justify-between items-center">
      <search-filter v-model="form.search" class="w-full max-w-md mr-4" @reset="reset">
        <!--        <label class="mt-4 block text-gray-700">Envoyer au superviseur:</label>-->
        <select v-model="form.sent" class="mt-1 w-full form-select">
          <option :value="null"/>
          <!--          <option value="with">Envoyer et non envoyer</option>
                    <option value="only">Envoyer uniquement</option>-->
        </select>
      </search-filter>
      <div class="flex">
      </div>
    </div>
    <div class="bg-white rounded shadow overflow-x-auto">
      <table class="w-full whitespace-no-wrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">N° Order</th>
          <th class="px-6 pt-6 pb-4">IMEI</th>
          <th class="px-6 pt-6 pb-4">Modele</th>
          <th class="px-6 pt-6 pb-4">Date reception</th>
          <th class="px-6 pt-6 pb-4">Accusé</th>
          <th class="px-6 pt-6 pb-4">Etat</th>
          <th class="px-6 pt-6 pb-4">Commentaire</th>
        </tr>
        <tr v-for="repair in repairs.data" :key="repair.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <span class="px-6 py-4 flex items-center focus:text-indigo-500" >
              {{ repair.id }}
              <icon v-if="repair.deleted_at" name="trash" class="flex-shrink-0 w-3 h-3 fill-gray-400 ml-2"/>
            </span>
          </td>
          <td class="border-t">
            <span class="px-6 py-4 flex items-center" tabindex="-1">
              {{ repair.imei }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-6 py-4 flex items-center" tabindex="-1">
              {{ repair.model }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-6 py-4 flex items-center" tabindex="-1">
              {{ repair.created_at }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-6 py-4 flex items-center" tabindex="-1">
              {{ repair.accused_by }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-6 py-4 flex items-center" tabindex="-1">
              {{ repair.state }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-6 py-4 flex items-center" tabindex="-1">
              {{ repair.comment }}
            </span>
          </td>

          <td class="border-t w-px">
            <span class="px-4 flex items-center" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400"/>
            </span>
          </td>
        </tr>
        <tr v-if="repairs.data.length === 0">
          <td class="border-t px-6 py-4" colspan="4">No reception found.</td>
        </tr>
      </table>
    </div>
    <pagination :links="repairs.links"/>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Layouts/AppLayout'
import mapValues from 'lodash/mapValues'
import pickBy from 'lodash/pickBy'
import SearchFilter from '@/Shared/SearchFilter'
import throttle from 'lodash/throttle'
import Pagination from '@/Shared/Pagination'
import LoadingButton from '@/Shared/LoadingButton'
import TextInput from "@/Shared/TextInput";
import SelectInput from '@/Shared/SelectInput'

export default {
  metaInfo: {title: 'Accusé De Reception Du Devis'},
  layout: Layout,
  components: {
    TextInput,
    Icon,
    SearchFilter,
    Pagination,
    LoadingButton,
    SelectInput
  },
  props: {
    errors: Object,
    repairs: Object,
    filters: Object,
  },
  data() {
    return {
      selectedItems: [],
      selectAll: false,
      sending: false,
      form: {
        search: this.filters.search,
        role: this.filters.role,
        sent: this.filters.sent,
      },
    }
  },
  watch: {
    form: {
      handler: throttle(function () {
        let query = pickBy(this.form)
        this.$inertia.replace(this.route('tech.QuoteReceivedList', Object.keys(query).length ? query : {remember: 'forget'}), {
          preserveScroll: true,
          preserveState: true,
        })
      }, 150),
      deep: true,
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
